<template>
<div class="mt-3">
    <h1>Account Info</h1>
      <form class="ms-4 " @submit.prevent="signUp">
      <h3 class="mt-3">Generic Info</h3>
  <div class="mb-3">
    <div v-if="showError" class="alert alert-danger" role="alert">
          {{errorText}}
        </div>
    <label for="inputClubName" class="form-label float-left">Name</label>
    <input v-model="name" type="text" class="form-control ms-1" id="inputClubName" required>
  </div>
  <div class="">
    <label for="inputEmail" class="form-label float-left ">Email Address</label>
    <input type="email" v-model="emailAddress" class="form-control ms-1" id="inputEmail" required>
    <button type="button" v-on:click="updateGenericInfo" class="btn btnAccent my-3 float-right">Save</button>
  </div>
   
  
<hr class="rounded">
<h3 class="mt-3">Password Reset</h3>
  <div class="mb-3">
    <label for="oldPassword" class="form-label float-left">Old Password</label>
    <input type="password" v-model="oldPassword" class="form-control ms-1" id="oldPassword" required>
  </div>
  <div class="mb-3">
    <label for="password" class="form-label float-left">Password</label>
    <input type="password" v-model="password" class="form-control ms-1" id="password" required>
  </div>
<div class="mb-3">
    <label for="passwordConfirm" class="form-label float-left">Password Confirmation</label>
    <input type="password" v-model="passwordConfirm" class="form-control ms-1" id="passwordConfirm" required>
    <button type="button" v-on:click="updatePassword" class="btn btnAccent my-3 float-right">Save</button>
  </div>


  <hr class="rounded">
  <h3 class="mt-3">Stripe Account <i v-if="!stripeComplete" class="ph-bold ph-warning warning"></i></h3>  
  <p v-if="stripeComplete">
    You already setup your stripe account, navigate to the <a target="_new" href="https://dashboard.stripe.com">Stripe Dashboard</a> to see your information/ validate your account.
    <button type="button" v-on:click="deauthorizeStripeAccount" class="btn btnAccent mx-2 my-2">Disconnect Stripe</button> 

  </p>
  <p v-else-if="accountCreated">
    If you did not finish setup click Setup Account Button: 
    <button type="button" v-on:click="onboardPayments" class="btn btnAccent mx-2">Setup Account</button> 
    <br>
     <i>If you completed, please wait 1-3 business days and login to</i> <a target="_new" href="https://dashboard.stripe.com">Stripe Dashboard</a> <i>to see status </i>

  </p>
  <div class="align" v-else>
    In order to handle payments within the application, you must create/link a stripe account here:
    <button type="button" v-on:click="onboardPayments" class="btn btnAccent mx-2">Setup New Account</button> 
    <button type="button" v-on:click="connectUser" class="btn btnAccent mx-2">Connect Existing Account</button> 

  </div>
  <hr class="rounded">
  <h3 class="mt-3">Delete Vibtap Account</h3>
  <button type="button" v-on:click="deleteFullAccount" class="btn btnAccent my-3">Delete</button>



</form>

</div> 
</template>
<script>
import swal from 'sweetalert';
import 'vue2-timepicker/dist/VueTimepicker.css'
import userService from "../../api/user.js"
import paymentService from '../../api/payments.js'


export default {
  name: 'Club-Details',
  components:{
  //  VueTimepicker
  },
    props: ['venue','index'],
  data() {
    return {
        name:"",
        oldPassword:"",
        password:"",
        addressSecond:"",
        passwordConfirm:"",
        emailAddress:"",
        businessCode:"",
        showError:false,
        errorText:"",
        loading:false,
        stripeSetup:false


    };
  },
  mounted(){
    if(sessionStorage.getItem('user')==null){
        swal( "Error" , "Screen data has been corrupted, please refresh and try again" ,  "error" )
      }
      else{
        console.log(this.$route.path)
        this.loading=true;
        userService.getGenericInfo(sessionStorage.getItem('user')).then(data=>{
           this.loading=false
          this.name = data.data.name
          this.emailAddress = data.data.email
          this.stripeSetup = data.data.stripeSetup
          sessionStorage.setItem('stripeAccountCreated', data.data.stripeAccountCreated);
          sessionStorage.setItem('chargesEnabled', data.data.chargesEnabled);
        })
      }
    
  },
  computed:{
    stripeComplete(){
      return sessionStorage.getItem('stripeAccountCreated') === "true" && sessionStorage.getItem('chargesEnabled') === "true";
    }, 
    accountCreated(){
      return sessionStorage.getItem('stripeAccountCreated') === "true";
    }
  },
  methods:{
    alertInfo(){
      swal("For Employees Only","Have whoever setup the business give you the 6 digit code to associate you to the business")
    },
    deleteFullAccount(){
      swal({
          title: 'Delete VibeTap Account',
          text: 'This will permanently delete your VibeTap account and all associated data within our application. This action cannot be undone. Your Stripe account will remain active and must be managed separately. Are you sure you want to continue?',
          buttons: {
            cancel: 'Cancel',
            confirm: 'Confirm',
          },
          closeOnClickOutside: false,
        })
        .then( async (value) => {
            if(value){
              this.loading=true;
            await userService.queueDeletion(sessionStorage.getItem('user'))
            sessionStorage.setItem('stripeAccountCreated',false)
            sessionStorage.setItem('chargesEnabled',false)
            await swal("Success", "Your Account has been deleted.", "success");
            this.$store.dispatch('setInitial') 
            this.$router.push({ name: 'Login',params: { refresh:true}}) 
            
            }
            });
    },
    onboardPayments(){
       this.loading=true;
      paymentService.onboardUser(sessionStorage.getItem('user'));
    },
    connectUser(){
       this.loading=true;
      paymentService.connectUser(sessionStorage.getItem('user'));
    },
    async deauthorizeStripeAccount(){
       swal({
          title: 'Disconnect Stripe Account?',
          text: 'This will remove the connection between your Stripe account and VibeTap. Your Stripe account will not be deleted and can still be managed on Stripe’s website.',
          buttons: {
            cancel: 'Cancel',
            confirm: 'Confirm',
          },
          closeOnClickOutside: false,
        })
        .then( async (value) => {
            if(value){
              this.loading=true;
            const response = await paymentService.deauthorizeStripeAccount(sessionStorage.getItem('user'))
            sessionStorage.setItem('stripeAccountCreated',false)
            sessionStorage.setItem('chargesEnabled',false)
            swal("Success",response.message, "success");
            window.location.reload();
            }
            });
    },
    updatePassword(){
      if(this.password.length<8){
        swal( "Error" , "Password must be at least 8 characters" ,  "error" )
      }
      else if(this.password!=this.passwordConfirm){
       swal( "Error" , "Password and Password Confirm don't match" ,  "error" )
      }
      else if(this.oldPassword==""){
        swal( "Error" , "Please enter old password" ,  "error" )
      }
      else{
        var body ={
            passwordCurrent:this.oldPassword,
            password: this.password,
            passwordConfirm: this.passwordConfirm
        }
         this.loading=true;
        userService.updatePassword(sessionStorage.getItem('user'),body)
      .then(data =>{
         this.loading=false;
        if(data.error){
           swal ( "Error" , "Something has gone wrong, please try again later" ,  "error" )
        }
        else{
           swal("Success", "Password has been updated!", "success");
        }

      });
      }
    },
    updateGenericInfo(){
      if(!this.checkIfEmail(this.emailAddress)){
      swal ( "Error" , "Please ensure that this is a valid email" ,  "error" )
      }
      else if(this.name.length==0){
          swal ( "Error" , "Name is required" ,  "error" )
      }
      else if(sessionStorage.getItem('user')==null){
        swal( "Error" , "Screen data has been corrupted, please refresh and try again" ,  "error" )
      }
      else {
       
        var user ={
            name:this.name,
            email: this.emailAddress,
        }
         this.loading=true;
            userService.updateGenericInfo(sessionStorage.getItem('user'),user)
      .then(data =>{
         this.loading=false;
        if(data.error){
           swal ( "Error" , "Something has gone wrong, please try again later" ,  "error" )

        }
        else{
           swal("Success", "User has been updated!", "success");
        }

      });
        
      }
    },
    checkIfEmail(str) {
  // Regular expression to check if string is email
  const regexExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;

  return regexExp.test(str);
}
  },
}
</script>
<style scoped>
.custom-label-height{
    height: 27px;
}
hr.rounded {
  border-top: 8px solid #bbb;
  border-radius: 5px;
  width: 100%;
}
.warning{
  color: purple;
}

    

</style>